module.exports = __webpack_public_path__ + "img/icon.dde87a01.svg";